import { type FC } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { InitialLoadingScreen } from './InitialLoadingScreen';
import { SessionManagerBridge } from './session/SessionManagerBridge';
import { LoadingOverlayModal } from './LoadingOverlayModal';
import { AppRoutes } from '@/routes';
import { MetaUpdater } from './MetaUpdater';
import '../styles/app.scss';

export const App: FC = () => {
  return (
    <InitialLoadingScreen>
      <Router basename="/">
        <div className="app">
          <SessionManagerBridge />
          <LoadingOverlayModal />
          <MetaUpdater />
          <AppRoutes />
        </div>
      </Router>
    </InitialLoadingScreen>
  );
};
